module.exports = __webpack_public_path__ + "img/E_2.6d8462e6.png";